module.exports = __webpack_public_path__ + "img/img9.225e33cd.png";